import type { InfiniteData } from "@tanstack/react-query";
import axios from "axios";

import type { SessionWithApplication, SessionWithCostAppUser } from "@virtual-brain-lib/types";

import env from "../environments";
import { infiniteQueryOptions } from "../query-client";

export const SESSIONS_PER_PAGE = 40;

type MySessionsPage = { sessions: SessionWithApplication[]; countTotal: number };
export type MySessionsInfiniteData = InfiniteData<MySessionsPage>;

export const getMySessions = infiniteQueryOptions({
	async queryFn({ pageParam }) {
		const response = await axios.get<MySessionsPage>(`${env.apiUrl}/sessions/me`, {
			params: { limit: SESSIONS_PER_PAGE, offset: pageParam },
		});

		return response.data;
	},
	queryKey: "mySessions",
	initialPageParam: 0,
	getNextPageParam(lastPage, allPages) {
		const loadedCount = allPages.reduce((total, page) => total + page.sessions.length, 0);

		return loadedCount < lastPage.countTotal ? loadedCount : undefined;
	},
});

export async function getSessionsWithCosts({
	from,
	to,
}: {
	from: string;
	to: string;
}): Promise<SessionWithCostAppUser[]> {
	const response = await axios.get<SessionWithCostAppUser[]>(
		`${env.apiUrl}/sessions?from=${from}&to=${to}`,
	);

	return response.data;
}

export async function updateSession(sessionId: string, title: string) {
	await axios.put(`${env.apiUrl}/sessions/${sessionId}`, { title });
}

export async function deleteSession(sessionId: string) {
	await axios.delete(`${env.apiUrl}/sessions/${sessionId}`);
}
